import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { ButtonConfig } from 'src/app/models/button.component.model';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'confirm-dialog',
  templateUrl: './confirmation-dialog.component.html',
})
// tslint:disable-next-line:component-class-suffix
export class ConfirmationDialog {
  public confirmMessage: string;
  buttonConfig = [new ButtonConfig('Ok', true, false,
  () => this.close(true)), new ButtonConfig('Cancel', false, true, () => this.close(false))];

  constructor(public dialogRef: MatDialogRef<ConfirmationDialog>) { }

  close(confirm: boolean) {
    this.dialogRef.close(confirm);
  }
}
